import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { AccBusyService } from './acc-busy.service';

const ACCOUNTING_API = '/api/v1/accounting/';
const READ_ONLY_METHODS = ['GET', 'HEAD', 'OPTIONS'];

/** Counts data-changing accounting requests so the clicked button can show progress. */
@Injectable()
export class AccBusyInterceptor implements HttpInterceptor {
  constructor(private readonly busy: AccBusyService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (READ_ONLY_METHODS.includes(request.method) || !request.url.includes(ACCOUNTING_API)) {
      return next.handle(request);
    }

    let failed = false;
    this.busy.begin();
    return next.handle(request).pipe(
      tap({ error: () => { failed = true; } }),
      finalize(() => this.busy.end(!failed))
    );
  }
}
